const swiper = new Swiper('.swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 50,

    breakpoints: {
        
        768: {
            slidesPerView: 2,
            spaceBetweenSlides: 50
        },

        991: {
            slidesPerView: 3,
            spaceBetweenSlides: 50
        }
    },

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
